import { render } from "./NewProviderProduct.vue?vue&type=template&id=c180b550&scoped=true"
import script from "./NewProviderProduct.vue?vue&type=script&lang=js"
export * from "./NewProviderProduct.vue?vue&type=script&lang=js"

import "./NewProviderProduct.vue?vue&type=style&index=0&id=c180b550&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c180b550"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QInnerLoading,QImg,QBtn});
